import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PageGetSlugService } from '../../services';

export const fetchPageGetSlug = createAsyncThunk(
    'pageGetSlug/fetchPageGetSlug',
    async ({ slug }) => {
        const response = await PageGetSlugService(slug)
        return response.result
    }
);

const pageGetSlugSlice = createSlice({
    name: 'pageGetSlug',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPageGetSlug.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchPageGetSlug.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchPageGetSlug.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default pageGetSlugSlice.reducer;
